type LayerValues = number[][];
type ReferenceValues = Record<string, LayerValues | Record<string, LayerValues>>;

export function getPrescriptionLegendValues(
  referenceValues: ReferenceValues,
  fieldId: number,
  sourceLayer: string
): LayerValues | undefined {
  const fieldValues = referenceValues[String(fieldId)];
  if (fieldValues && !Array.isArray(fieldValues)) {
    return fieldValues[sourceLayer];
  }

  const layerValues = referenceValues[sourceLayer];
  return Array.isArray(layerValues) ? layerValues : undefined;
}
